import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import SivReportListView from 'src/components/StartUp/sivReport/SivReportListView';
import SivReport from 'src/components/StartUp/sivReport/SivReport';

const initialState: any = {
  showCMPArr: [
    {
      cmp: SivReportListView,
      key: 'sivreportview',
      curruntlyActive: true
    },
    {
      cmp: SivReport,
      key: 'sivReportpage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {},
  disableSaveButtonProps: {
    clinicalTrialDetails: true,
    siteAdequacy: true,
    informConcent: true,
    adverseEventReporting: true,
    monitoring: true,
    requirementsforECrfcompletion: true,
    sourceDocumentation: true,
    confirm: true
  }
};

export const sivReport = createSlice({
  name: 'sivReport',
  initialState,
  reducers: {
    setChckListCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedRowData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    },
    setIsSaveButtonDisable: (state, action: PayloadAction<any>) => {
      state.disableSaveButtonProps = action.payload;
    }
  }
});

export const { setChckListCMPArr, setSelectedRowData, setIsSaveButtonDisable } = sivReport.actions;
